import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import tabbar from "./tabbar"
import system from "./systemConfig"
import coins from '../view/p2p/models'
import { Api } from '@/api'
import { init } from "./init"

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false,
  state: {
    PopUp: false,
    index: 0,
    levels: []
  },
  mutations: {
    updataCount (state,data){
      state.PopUp = data
    },
    upindex(state, data) {
      state.index = data
    },
    getLevel(state){
      Api.getLevel(res=>{
        state.levels = res;
      })
    }
  },
  modules: {
    user,
    tabbar,
    system,
    coins,
    init
  }
})
